import React, { useState } from 'react';
import { Stack, Button, Modal, TextField, useMediaQuery, Box } from '@mui/material';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker, viVN } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

const AddCommunicationModal = ({ time, open, handleAdd, handleClose, note = '' }) => {
    const [_time, setTime] = useState(time);
    const [_note, setNote] = useState(note);
    const [selectedFile, setSelectedFile] = useState(null);
    const isMobile = useMediaQuery('(max-width:600px)');

    const onClose = () => {
        if (handleClose) {
            handleClose();
        }
    };

    const onAdd = () => {
        if (handleAdd && _time && _note) {
            const formData = new FormData();
            formData.append('schedule_time', dayjs(_time).format());
            formData.append('note', _note);
            if (selectedFile) {
                const extension = selectedFile.name && selectedFile.name.includes('.')
                    ? `.${selectedFile.name.split('.').pop().toLowerCase()}`
                    : '';
                const safeFileName = `${Date.now()}_${Math.floor(Math.random() * 1000000)}${extension}`;
                formData.append('attached_file', selectedFile, safeFileName);
            }
            handleAdd(formData);
            setNote('');
            setSelectedFile(null);
        }
    };

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90%' : 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Stack spacing={2}>
                    <h4 style={{ textAlign: 'center' }}>Thêm thông tin nhắn tin/gọi điện khách hàng</h4>
                    <TextField
                        label="Nội dung liên lạc"
                        fullWidth
                        multiline
                        rows={3}
                        variant="standard"
                        placeholder='Vd (gọi điện, nhắn tin với nội dung "aaa")'
                        value={_note}
                        onChange={(e) => setNote(e.target.value)}
                    />

                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        localeText={viVN.components.MuiLocalizationProvider.defaultProps.localeText}
                        adapterLocale="vi"
                    >
                        <DemoContainer
                            components={['StaticDateTimePicker', 'MobileDateTimePicker']}
                        >
                            <DemoItem label="Thời gian liên hệ">
                                <MobileDateTimePicker
                                    value={_time}
                                    onChange={(value) => setTime(value)}
                                    format="HH:mm DD/MM/YYYY"
                                    label="Thời gian liên hệ"
                                />
                            </DemoItem>
                        </DemoContainer>
                    </LocalizationProvider>

                    <span style={{ fontSize: 14, color: 'black' }}>Chọn file đính kèm (ảnh hoặc ghi âm, nếu có)</span>
                    <input
                        type="file"
                        accept="audio/*,image/*"
                        onChange={handleFileChange}
                        style={{ marginTop: '16px' }}
                    />

                    <Stack
                        flexDirection="row"
                        style={{ marginTop: '48px' }}
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                    >
                        <Button onClick={handleClose} color="warning" style={{ flex: 1 }}>
                            Huỷ
                        </Button>
                        <Button
                            disabled={!_time || !_note}
                            onClick={onAdd}
                            color="success"
                            style={{ flex: 1 }}
                        >
                            Thêm tin nhắn
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default AddCommunicationModal;